import React, { useEffect } from 'react'
import { Separator } from '../../../../../../../../../EHR/utils/utils';
// Viewer Component for Displaying the Checklist
const CheckList = ({ item, setItem, activeAccordion }) => {

    const selectedOptions = item.selectedOptions?.split(Separator).length > 0
        ? item.selectedOptions.split(Separator).map(optStr => {
            const hasSelected = optStr.includes("(D)");
            const baseLabel = optStr.split("(D)")[0].split("[")[0];

            console.log("selectedOptionschecklist selectedOptions", hasSelected)

            const metaMatch = optStr.match(/\[(.*?)\]/);
            let textResponse = "false";
            let hintText = "";
            let value = "";

            if (metaMatch) {
                const parts = metaMatch[1].split("|");
                parts.forEach(p => {
                    if (p.startsWith("TR=")) textResponse = p.split("=")[1];
                    if (p.startsWith("hintText=")) hintText = p.split("=")[1].replace(/'/g, "");
                    if (p.startsWith("value=")) value = p.split("=")[1].replace(/'/g, "");
                });
            }

            return {
                content: baseLabel,
                checked: hasSelected,
                textResponse: textResponse,
                hintText: hintText,
                value: value
            };
        })
        : [];
    const checkedOptions = selectedOptions.filter(opt => opt?.checked);
    console.log("selectedOptionschecklist", item.selectedOptions, selectedOptions, "checkedOptions", checkedOptions)
    return (
        <div>
            <div className="d-flex flex-column gap-6">
                {checkedOptions.length > 0 ? (
                    checkedOptions.map((option, index) => (
                        <div key={index} className="custom_check_box d-flex gap-6 checkbox-multiline-alignment">
                            <i className="icon-check fs-15 fw-900"></i>
                            <p 
                                className="text fs-14 text-black" 
                                style={{ whiteSpace: "pre-line" }}
                            > {option.content}</p>

                            {option.textResponse === "true" && option.value && (
                                <p className="text fs-14 text-black">- {option.value}</p>
                            )}

                            {/* {index !== checkedOptions.length - 1 && ', '} */}
                        </div>
                    ))
                ) : (
                    <p className="text fs-14 text-black">N/A</p>
                )}
            </div>
        </div>
    );
};

export default CheckList;